import useTracking from "../../common/tracking/ninja/useTracking";
import { useCallback } from "react";
function normalizeExtraData(paramName, raw) {
    if (raw === undefined || raw === "") {
        return { [paramName]: "" };
    }
    const asArray = Array.isArray(raw) ? raw.map(String) : [String(raw)];
    return {
        [paramName]: asArray.length === 1 ? asArray[0] : asArray,
    };
}
/**
 * Ninja tracking for URL path filters (finance_type, monthly_price),
 * aligned with legacy resources/js/partials/offers-config.js.
 * Start + valid fire together only when the user changes a value (not on accordion open).
 */
export function usePathFilterTracking() {
    const { trackEvent } = useTracking();
    const trackSegmentCommit = useCallback((filter, selectedState) => {
        const t = filter.tracking;
        if (!t)
            return;
        if (t.startEvent)
            trackEvent(t.startEvent);
        if (t.validEvent && t.paramName) {
            trackEvent(t.validEvent, normalizeExtraData(t.paramName, selectedState[filter.id]));
        }
    }, [trackEvent]);
    return { trackSegmentCommit };
}
